import { Stack } from '@mui/material';
import { StyledButton } from './mailing-list-form.styles';

export const MailingListForm = () => (
  <form
    action="https://carlhauck.us4.list-manage.com/subscribe/post?u=d922a56af33493e17360136cf&id=8cbfb68093&f_id=004a39ebf0"
    method="post"
    target="_blank"
    rel="noopener noreferrer"
    style={{ display: "flex", flexDirection: "column", gap: 8, maxWidth: 400 }}
  >
    <Stack spacing={1} direction="row" alignItems="center">
      <input
        type="email"
        name="EMAIL"
        id="mce-EMAIL"
        required
        placeholder="mailing list signup"
        style={{ padding: 8, fontSize: 15 }}
      />
      {/* Honeypot field for bots */}
      <div style={{ position: "absolute", left: -5000 }}>
        <input type="text" name="b_d922a56af33493e17360136cf_8cbfb68093" tabIndex={-1} />
      </div>
      <StyledButton type="submit">Subscribe</StyledButton>
    </Stack>
  </form>
);

